export default "__VITE_ASSET__wOAtjKDB__ 36w, __VITE_ASSET__CL6T_yhg__ 72w, __VITE_ASSET__Cf5biUZG__ 108w";